let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1H6Jv")).then(() => parcelRequire('a8pwQ'));